var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g({staticClass:"default-checkbox",attrs:{"id":_vm.name,"type":"checkbox"}},_vm.eventsListeners))}
var staticRenderFns = []

export { render, staticRenderFns }